import { apiClient } from './axios'

//csapat adatok beolvasása
/**
 *
 * @returns {
 *  name: string,
 *  created_by_user_id: uuid,
 *  created_at: date,
 *  updated_at: date,
 * }
 */
export const getTeam = async (competitionId) => {
  return await apiClient.get(`api/teams/${competitionId}`)
}

export const checkTeamName = async (name, competitionId) => {
  try {
    return (await apiClient.get(`api/check-team`, {params: {name, competitionId}})).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

/**
 *
 * @param {string} name
 * @returns bool
 */
export const postTeam = async (teamData, competitionId) => {
  try {
    return await apiClient.post(`api/teams/${competitionId}`, teamData)
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

/**
 *
 * @param {string} name
 * @returns bool
 */
export const putTeam = async (teamData, competitionId) => {
  try {
    return await apiClient.put(`api/teams/${competitionId}`, teamData)
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}
